export const GET_DATA_COMPANIES= 'GET_DATA_COMPANIES';

export const getDataCompanies = company => ({
    type: GET_DATA_COMPANIES,
    payload: {company}
});